const PREFIX = 'TIMEZONES';

export const LIST_TIMEZONES = `${PREFIX}/LIST`;
export const GET_TIMEZONE = `${PREFIX}/GET`;
